import React from 'react';
import { cn } from '@/lib/utils';
import StatusPill from './StatusPill';

interface SectionHeaderProps {
  title: string;
  /** Optional count shown as a neutral pill next to the title. */
  count?: number;
  /** Optional trailing action, e.g. a "See all" link. */
  action?: React.ReactNode;
  className?: string;
}

/** Section title row (Figma "Section header"). */
const SectionHeader: React.FC<SectionHeaderProps> = ({ title, count, action, className }) => (
  <div className={cn('tw-flex tw-items-center tw-gap-2.5', className)}>
    <h2 className="tw-whitespace-nowrap tw-text-[17px] tw-font-semibold tw-leading-6 tw-text-ds-text-primary">{title}</h2>
    {count !== undefined && <StatusPill tone="neutral">{count}</StatusPill>}
    <span className="tw-flex-1" />
    {action}
  </div>
);

export default SectionHeader;
